import type { DocDeepSignal } from '@/data/data-utils.ts'
import type { User } from '@/data/User.ts'
import { signal } from '@/react/core/reactive.ts'

export const [loginUser, setLoginUser] = signal<User | undefined>()
export const [users0, setUsers0] = signal<Array<DocDeepSignal<User>>>([])
